// Centralised route constants for the treasury accounts (settlement
// bank accounts) module. Backend route renames are a one-file change.

const TREASURY_BANK_ACCOUNTS = '/api/admin/treasury/bank-accounts'

export const TREASURY_ACCOUNTS_ENDPOINT_PATHS = {
  LIST: TREASURY_BANK_ACCOUNTS,
  CREATE: TREASURY_BANK_ACCOUNTS,
  UPDATE: (id: string) => `${TREASURY_BANK_ACCOUNTS}/${id}`,
  DEACTIVATE: (id: string) => `${TREASURY_BANK_ACCOUNTS}/${id}/deactivate`,
  SET_DEFAULT: (id: string) => `${TREASURY_BANK_ACCOUNTS}/${id}/set-default`,
} as const
